import { render, staticRenderFns } from "./SpectrumFigure.vue?vue&type=template&id=216705fa&scoped=true"
import script from "./SpectrumFigure.vue?vue&type=script&lang=js"
export * from "./SpectrumFigure.vue?vue&type=script&lang=js"
import style0 from "./SpectrumFigure.vue?vue&type=style&index=0&id=216705fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216705fa",
  null
  
)

export default component.exports